/**
 * Checks if the structure is infinitely recursive
 * @param structureModel
 */
export function isRecursive(structureModel) {
    for (const root of structureModel.roots) {
        for (const cls of root.classes) {
            if (DfsIsRecursive(cls, [])) {
                return true;
            }
        }
    }
    return false;
}
function DfsIsRecursive(cls, iriChain) {
    const iri = cls.psmIri;
    if (iriChain.includes(iri)) {
        return true;
    }
    iriChain.push(iri);
    for (const property of cls.properties) {
        for (const dataType of property.dataTypes) {
            if (dataType.isAssociation()) {
                if (DfsIsRecursive(dataType.dataType, iriChain)) {
                    iriChain.pop();
                    return true;
                }
            }
        }
    }
    for (const parent of cls.extends) {
        if (DfsIsRecursive(parent, iriChain)) {
            iriChain.pop();
            return true;
        }
    }
    iriChain.pop();
    return false;
}
//# sourceMappingURL=is-recursive.js.map